<template>
  <template v-if="tag === 'a'">
    <a class="btn btn-primary" :href="href"> 
      <slot />
    </a>
  </template>
  <template v-else-if="tag === 'button'">
    <button
      :type="type"
      class="btn relative"
      :class="{
        [buttonColorClass]: !flat && !outlined,
        'btn-ghost': flat,
        'btn-outline': outlined,
        'btn-disabled': disabled,
        'btn-loading': loading,
        buttonSizeClass: size
      }"
      :disabled="disabled || loading"
      @click="handleClick"
    >
      <div :class="{ 'invisible': loading }">
        <slot />
      </div>

      <font-awesome-icon v-if="loading" class="absolute text-primary" :icon="faSpinner" spin size="xl" />
    </button>
  </template>
</template>

<script>
  import { faSpinner } from '@fortawesome/free-solid-svg-icons';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },
  name: "DBtn",
  props: {
    type: {
      type: String,
      default: "button",
    },
    flat: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
      validator: (value) =>
        [
          "neutral",
          "primary",
          "secondary",
          "secondary-500",
          "accent",
          "info",
          "success",
          "warning",
          "error",
          "custom",
        ].indexOf(value) !== -1,
    },
    size: {
      type: String,
      default: "",
      validator: (value) =>
        [
          "",
          "xs",
          "btn-xs",
          "sm",
          "btn-sm",
          "md",
          "btn-md",
          "lg",
          "btn-lg",
        ].indexOf(value) !== -1,
    },
    href: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      faSpinner,
    };
  },

  emits: ["click"],

  computed: {
    tag() {
      if (this.href) {
        return "a";
      } else {
        return "button";
      }
    },

    buttonSizeClass() {
      switch (this.size) {
        case "xs":
        case "btn-xs":
          return "btn-xs";
        case "sm":
        case "btn-sm":
          return "btn-sm";
        case "lg":
        case "btn-lg":
          return "btn-lg";
        case "xl":
        case "btn-xl":
          return "btn-xl";
        default:
          return "";
      }
    },

    buttonColorClass() {
      switch (this.color) {
        case 'neutral':
          return 'btn-neutral';
        case 'primary':
          return 'btn-primary';
        case 'secondary':
        case 'secondary-500':
          return 'btn-secondary';
        case 'accent':
          return 'btn-accent';
        case 'info':
          return 'btn-info';
        case 'success':
          return 'btn-success';
        case 'warning':
          return 'btn-warning';
        case 'error':
          return 'btn-error';
        case 'custom':
          return 'btn-custom';
        default:
          return 'btn-primary';
      }
    },
  },

  methods: {
    handleClick(event) {
      this.$emit("click");
    },
  },
};
</script>
